





















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {User, Info, Device, Column} from '@/types/core';
import { Probe } from '@/types/nfresh';
import moment from 'moment';

import VueError from '@/components/VueError.vue';
import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';

import tippy from 'tippy.js';

import MobileFriendlyRow from '@/components/MobileFriendlyRow.vue';

@Component({
  components:{
    VueError,
    EnterpriseId,
    TimestampAgo,
    MobileFriendlyRow
  }
})
export default class NfreshProbeRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) probe!: Probe;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;
  @Prop({ default: 'deviceId',  type: String}) orderBy!: 'deviceId'|'lastOnline'|'lastReading'|'enterpriseId';
  @Prop({ default: 'asc',  type: String}) ascDesc!: 'asc'|'desc';

  cols:Column[] = [
    {colName: 'device-id',
      colStyle:{ width: '160px'},
      colKey:'deviceId',
      sortable: true},
    {colName: 'hum.',
      colStyle:{ width: '16%'},
      colKey:'humidity',
      sortable: false},
    {colName: 'temp.',
      colStyle:{ width: '18%'},
      colKey:'temperature',
      sortable: false}
  ];

  async mounted() {
    // nothing yet

    tippy('[data-tippy-content]');
  }

  toggleOrder(newOrderBy:'deviceId'|'deviceType'|'lastOnline'|'enterpriseId') {
    
    // we are clicking on what we are ordering by already
    if(this.orderBy === newOrderBy)
      return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: this.ascDesc === 'asc' ? 'desc' : 'asc'});

    // we are clicking on another column -> we default to asc
    switch(newOrderBy) {
      case 'deviceId': 
      case 'deviceType': 
      case 'enterpriseId':
        return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: 'asc'});
      case 'lastOnline': 
        return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: 'desc'});
    }
    
  }

  goToProbePage(deviceId:string) {
    this.$router.push(`/applications/nfresh/probes/${deviceId}`);
  }

  get protocolVersion() {
    return this.probe.protocolVersion ? this.probe.protocolVersion : '0';
  }

  get firmwareVersion() {
    return this.probe.status ? this.probe.status.firmwareVersion : '1.0';
  }

}

